var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',{attrs:{"mode":"out-in"}},[_c('keep-alive',[_c(_vm.selectComponent,{tag:"component",attrs:{"valid":_vm.valid},on:{"media":_vm.emitMedia,"valid":_vm.emitValid},model:{value:(_vm.computedKnowledgeUnit),callback:function ($$v) {_vm.computedKnowledgeUnit=$$v},expression:"computedKnowledgeUnit"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }